import React from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import styled, { css } from 'styled-components';
import { themeGet } from 'styled-system';

import withResponsive from '../../hoc/withResponsive'
import Box from '../Box'

const selector = css`
  border: 1px solid ${themeGet('colors.variations.gray.2')};
  border-radius: 0;
  background-color: white;
  color: ${themeGet('colors.text')};
  font-family: inherit;
  padding: 1em 52px 1em 1em;
`

const StyledNativeSelect = styled.select`
  width: 100%;
  display: block;
  ${selector}
  > option {
    padding: 0;
    min-height: 1em;
  }
`

const StyledDropdown = styled(Dropdown)`
  .Dropdown-control {
    ${selector}
  }
  .Dropdown-option {
    color: inherit;
    padding: 0.5em 1em;
    &.is-selected {
      background-color: ${themeGet('colors.primary')};
      color: ${themeGet('colors.primaryInvert')};
    }
    &:hover {
      background-color: ${themeGet('colors.primaryHover')};
      color: ${themeGet('colors.primaryInvert')};
    }
  }
  .Dropdown-arrow {
    border-color: ${themeGet('colors.primary')} transparent transparent;
    top: 1.4em;
    right: 1em;
  }
`

const CustomDropdown = ({
  isMobile,
  options,
  onChange,
  onBlur,
  value,
  name,
  placeholder,
  disabled,
  ...props
}) => {
  return (
    <Box {...props}>
      {isMobile ? (
        <StyledNativeSelect
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {options.map(({ label }, i) => (
            <option key={i} value={i}>{label}</option>
          ))}
        </StyledNativeSelect>
      ) : (
        <StyledDropdown
          onChange={e => onChange({ target: { name, value: e.value }, persist: () => {} })}
          options={options.map(({ label }, value) => ({ value, label }))}
          value={Object.assign({}, options[+value], { value })}
          placeholder={placeholder}
          disabled={disabled}
        />
      )}
    </Box>
  );
};

CustomDropdown.defaultProps = {
  placeholder: '請選擇',
}

export default withResponsive(CustomDropdown);
